import React from "react";
import { PropertyIcon } from "../../../icons";
import { formatAddress } from "../../../utils/formatAddress";
import { Address } from "../../../api/services";
import { PanelHeader } from "../../../components/PanelHeader";
import { BoxProps } from "@material-ui/core";

export const PropertyHeader: React.FC<
  { address: Address; gutter?: number } & BoxProps
> = ({ address, gutter, ...props }) => (
  <PanelHeader
    icon={<PropertyIcon />}
    title={formatAddress(address)}
    gutter={gutter}
    data-testid="Property__Header"
    {...props}
  />
);
